<div class="d-flex justify-content-center m">
  <div class="card">
    <div class="card-header text-center">
      <h4 class="display-5">Send Event To Students</h4>
    </div>
    <form #uploadform="ngForm" name="uploadform" class="ml-5 mr-5 mt-4">

      <div class="mb-3">
        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="name" class="legend">Subject: <span class="requiredfield">*</span></label>
              <input class="text-field" required type="text" id="mailSubject" name="mailSubject"
                [(ngModel)]="mailSubject" autofocus>
            </div>
          </div>

          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="name" class="legend">Venue/link: <span class="requiredfield">*</span></label>
              <input class="text-field" required type="text" id="venue" name="venue" [(ngModel)]="venue">
          <button class="generate-meeting-link-button btn wlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto align-items-center px-3 bg-transparent border-0 text-body" title="Generate Meeting Link" (click)="getMeetingID()" [disabled]="this.headerinfo.pageloading" [hidden]="!!venue"><i class="fas fa-plus"></i></button>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="startt" class="legend">Event StartDate: <span class="requiredfield">*</span></label>
              <input [owlDateTime]="rawStartTime" class="text-field" id="inviteStartDate" name="inviteStartDate"
                [(ngModel)]="inviteStartDate">
              <button [owlDateTimeTrigger]="rawStartTime" type="button"
                class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                title="Calendar"><i class="fa fa-calendar"></i></button>
              <owl-date-time #rawStartTime></owl-date-time>
            </div>
          </div>

          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="endt" class="legend">Event EndDate: <span class="requiredfield">*</span></label>
              <input [owlDateTime]="rawEndTime" class="text-field" id="inviteEndDate" name="inviteEndDate"
                [(ngModel)]="inviteEndDate">
              <button [owlDateTimeTrigger]="rawEndTime" type="button"
                class="owlDateTimeTrigger position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                title="Calendar"><i class="fa fa-calendar"></i></button>
              <owl-date-time #rawEndTime></owl-date-time>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg" *ngIf="lessons">
              <label class="legend" for="allowEnroll">Lesson:</label>
              <select class="text-field" [(ngModel)]="lessonId" name="lessonId">
                <option *ngFor="let lesson of lessons" [ngValue]="lesson.id">
                  {{lesson.title}}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="fieldset fieldset--lg " *ngIf="allowBatch">
              <label class="legend" for="allowEnroll">Batch: <span class="requiredfield">*</span></label>
              <select class="text-field" [(ngModel)]="selectedBatchId" name="selectedBatchId">
                <option [ngValue]="defaultBatch.id">
                  {{defaultBatch.name}}
                </option>
                <option *ngFor="let moduleBatch of moduleBatches" [ngValue]="moduleBatch.id">
                  {{moduleBatch.name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <quill-editor placeholder="Enter Summary" classes="ql-container--lg event-summary" required [(ngModel)]="mailBody"
        [ngModelOptions]="{standalone: true}"></quill-editor>
      <div class="card-footer p-0 mt-4">
        <div class="d-flex justify-content-around">
          <div class="row">
            <div class="col-md-5">
              <button type="submit" class="btn btn--warning m-1" (click)="testInviteMail()"
                [disabled]="disableButtons">Test
                Event Invitation</button>
            </div>
            <div class="col-lg-5">
              <button type="submit" class="btn m-1" [disabled]="disableButtons" (click)="sendInviteMail()">Send Event
                Invitation</button>
            </div>


          </div>

        </div>
      </div>
    </form>
  </div>
</div>
